import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";
import { Newspaper } from "lucide-react";
import MediaCard from "../../components/MediaCard";

const News = () => {
  const { ref, inView } = useInView({ threshold: 0.1, triggerOnce: true });

  const newsItems = [
    {
      title: "Young Indian Cooperator Harsh Shines at CM50 Global Conference",
      date: "November 2024",
      excerpt: "Harsh Sanghani represents global youth at CM50 Cooperative Ministers Conference in Doha, advocating for cooperatives as the Third Way of Economy",
      category: "Media Coverage",
      link: "https://www.indiancooperative.com/featured/young-indian-cooperator-harsh-shines-at-cm50-global-conference/"
    },
    {
      title: "Historic Election as ICA Youth President",
      date: "July 2025",
      excerpt: "First Indian in 130 years elected to lead International Cooperative Alliance Youth Committee",
      category: "Leadership",
      link: "#"
    },
    {
      title: "UN Youth Forum Representation",
      date: "June 2025",
      excerpt: "Representing youth voices from 110+ countries at United Nations Economic and Social Council",
      category: "Global Impact",
      link: "#"
    },
    {
      title: "Kaizenith Technologies Launch",
      date: "January 2025",
      excerpt: "New technology venture focused on innovation and digital transformation",
      category: "Business",
      link: "#"
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-red-900 to-red-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            className="text-center"
          >
            <Newspaper className="w-16 h-16 text-white mx-auto mb-6" />
            <h1 className="text-5xl font-bold text-white mb-4">News</h1>
            <p className="text-xl text-red-100 max-w-2xl mx-auto">
              Latest updates and announcements from global initiatives
            </p>
          </motion.div>
        </div>
      </section>

      {/* News Grid */}
      <section ref={ref} className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {newsItems.map((item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                animate={inView ? { opacity: 1, y: 0 } : {}}
                transition={{ delay: index * 0.1, duration: 0.6 }}
              >
                <MediaCard {...item} />
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default News;
